// extracted by mini-css-extract-plugin
export default {"card":"H2-z"};